<template>
  <vue-final-modal
    classes="modal-container"
    content-class="modal-content"
    v-model="dialogVissible"
    v-bind="$attrs"
    :resize="resize"
    :drag="drag"
    :click-to-close="false"
    :esc-to-close="false"
    drag-selector=".modal-drag"
    :style="cssVars"
    attach="body"
  >
    <div class="modal__holder">
      <div class="modal__head">
        <slot name="head"></slot>
        <el-icon class="drag-btn modal-drag">
          <TopRight />
        </el-icon>
        <el-icon @click="dialogVissible = false" class="close-btn"
          ><Close
        /></el-icon>
      </div>
      <div class="modal__body">
        <slot name="body"></slot>
      </div>
      <div class="modal__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  props: {
    modelValue: {
      default: false,
    },
    resize: {
      default: true,
    },
    drag: {
      default: true,
    },
    maxWidth: {
      default: null,
    },
    defaultWidth: {
      default: "40%",
    },
  },
  computed: {
    cssVars() {
      return {
        "--max-width": this.maxWidth + "px",
        "--default-width": this.defaultWidth,
      };
    },
    dialogVissible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style lang="scss">
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  position: relative;
  width: var(--default-width);
  max-height: 98%;
  max-width: var(--max-width);
  padding: 0;
  overflow: hidden;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: 8px 8px 0 0;
  cursor: pointer;
}
.modal-close::hover {
  color: gray;
}

.modal {
  &__holder {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #737daf;
    margin: 0 0 5px;
    padding: 10px 59px 10px 20px;
    position: relative;
    min-height: 50px;
    h3 {
      margin: 0 10px 0 0;
      display: block;
      font-weight: bold;
      font-size: 24px;
    }
    .drag-btn {
      position: absolute;
      left: auto;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      font-weight: bold;
      margin: 0;
      padding: 5px;
      width: 26px;
      height: 26px;
      transition: all 0.35s ease 0s;
      border-radius: 0 0 0 10px;
      cursor: pointer;
      &:hover {
        background: rgba($color-blue, 0.2);
      }
      svg {
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
    }
    .close-btn {
      position: absolute;
      left: auto;
      right: 25px;
      top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      font-weight: bold;
      margin: 0;
      padding: 5px;
      width: 30px;
      height: 30px;
      transition: all 0.35s ease 0s;
      border-radius: 50%;
      cursor: pointer;
      &:hover {
        background: rgba($color-blue, 0.2);
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
  &__body {
    flex: 1 1 auto;
    overflow: auto;
    padding: 10px 20px;
  }
  &__footer {
    padding: 10px 20px;
    border-top: 1px solid #737daf;
    .submit-box {
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      justify-content: space-between;
    }
  }
}
</style>
